import React from 'react';

import { Field, Form } from 'react-final-form';

import { Translate } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { Input } from '@change-corgi/design-system-legacy/components/forms';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import type { MediaHitValues } from '../../shared/context/types';

import { MediaSubmitMessages } from './components/MediaHitSubmitMessages';
import { useAddMediaHit } from './hooks/useAddMediaLinks';

export function AddMediaHit(): React.JSX.Element | null {
	const {
		data: { loading },
		actions: { validateLink, handleSubmitMediaHit: handleSubmitMediaLink },
	} = useAddMediaHit();

	return (
		<>
			<Box
				data-testid="add-media-wrapper"
				sx={{
					background: 'sunrise.semantic.fill.accent.primary.weaker',
					borderRadius: 'standard',
					marginTop: 52,
				}}
				p={16}
			>
				<Heading as="h3" size={['h5', 'h4']} mb={8}>
					<Translate value="corgi.petition_gamma.media_mentions.add.title" />
				</Heading>
				<Text as="p" size="small" mb={8} sx={{ whiteSpace: 'pre-line' }}>
					<Translate value="corgi.petition_gamma.media_mentions.add.description" />
				</Text>

				<Form<MediaHitValues>
					onSubmit={handleSubmitMediaLink}
					initialValues={{ link: '' }}
					subscription={{ pristine: true, submitting: true }}
				>
					{({ handleSubmit }) => (
						<form onSubmit={handleSubmit}>
							<Flex
								sx={{
									flexDirection: ['column', null, 'row'],
									alignItems: ['', null, 'flex-start'],
									gap: 16,
								}}
								mb={8}
							>
								<Box sx={{ width: ['100%', null, '60%'] }}>
									<Field<string> name="link" type="text" validate={validateLink}>
										{({ input, meta }) => {
											return (
												<Input
													{...input}
													id="add-media-link"
													type="text"
													label="Media URL"
													hideLabel
													placeholder="https://www.link.com"
													data-testid="add-media-link-input"
													data-qa="add-media-link-input"
													sx={{ width: '100%', height: '44px' }}
													error={
														(meta.active || meta.submitFailed) && typeof meta.error === 'string'
															? meta.error
															: undefined
													}
												/>
											);
										}}
									</Field>
								</Box>
								<Button
									variant="secondary"
									type="submit"
									data-testid="add-media-link-button"
									data-qa="add-media-link-button"
									loading={loading}
									sx={{ width: ['100%', null, '40%'] }}
								>
									<Translate value="corgi.petition_gamma.media_mentions.add.action" />
								</Button>
							</Flex>
						</form>
					)}
				</Form>
			</Box>

			<MediaSubmitMessages />
		</>
	);
}
